import { Injectable } from "@angular/core";
import { Watch } from "../models/watch";
import { Observable, of } from "rxjs";
import { map, catchError } from "rxjs/operators";
import { BrandService } from "./brand.service";

@Injectable({ providedIn: "root" })
export class WatchTransformationService {
  constructor(private brandService: BrandService) {}

  transformWatchesWithBrandName(watches: Watch[]): Watch[] {
    return watches.map((watch) => ({
      ...watch,
      brandName: this.getBrandNameForWatch(watch),
    }));
  }

  addBrandNameToWatch(watch: Watch): Observable<Watch | undefined> {
    if (watch && watch.brand.id) {
      return this.brandService.getBrandById(watch.brand.id).pipe(
        map((brand) => {
          watch.brand.name = brand?.name ?? "";
          return watch;
        }),
        catchError((err) => {
          watch.brand.name = "Unknown";
          return of(watch);
        })
      );
    }
    return of(watch);
  }

  private getBrandNameForWatch(watch: Watch): string {
    return watch.brand.name ?? "Unknown";
  }
}
